import React, { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import axios from "axios";
import { Spin, Result, Button } from "antd";
import { toast } from "react-toastify";

const PaypalSuccess = () => {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);
    const [captureStatus, setCaptureStatus] = useState(null);

    const orderNumber = searchParams.get("order_number");
    const paypalOrderId = searchParams.get("token");

    useEffect(() => {
        const capturePayment = async () => {
            if (!orderNumber || !paypalOrderId) {
                toast.error("Invalid PayPal return data");
                setLoading(false);
                return;
            }
            try {
                const res = await axios.post(`${process.env.REACT_APP_API_URL}api/paypal/capture`,
                    {
                        order_number: orderNumber,
                        paypal_order_id: paypalOrderId,
                    }
                );
                if (res.data?.status === true && res.data?.payment_status === "paid") {
                    toast.success("Payment successful!");
                    setCaptureStatus("success");
                    Object.keys(localStorage).forEach((key) => {
                        if (!isNaN(key) || key === "order") localStorage.removeItem(key);
                    });
                    window.dispatchEvent(new Event("cartUpdated"));
                    // setTimeout(() => {
                    //     navigate("/thankyou", {
                    //         state: { order_number: orderNumber, from: "paypal" },
                    //     });
                    // }, 2000);
                } else {
                    toast.error("Payment not completed.");
                    setCaptureStatus("failed");
                }
            } catch (err) {
                console.error(err);
                toast.error("Error capturing PayPal payment.");
                setCaptureStatus("failed");
            } finally {
                setLoading(false);
            }
        };

        capturePayment();
    }, [orderNumber, paypalOrderId, navigate]);

    if (loading) {
        return (
            <div className="flex justify-center items-center h-[80vh]">
                <Spin size="large" tip="Verifying your payment..." />
            </div>
        );
    }

    return (
        <div className="flex justify-center items-center h-[80vh]">
            {captureStatus === "success" ? (
                <Result
                    status="success"
                    title="Payment Successful!"
                    subTitle={`Your order #${orderNumber} has been paid successfully.`}
                    extra={[
                        <Button type="primary" key="home" onClick={() => navigate("/")}>
                            Go to Home
                        </Button>,
                    ]}
                />
            ) : (
                <Result
                    status="error"
                    title="Payment Failed"
                    subTitle="Something went wrong while confirming your PayPal payment."
                    extra={[
                        <Button key="retry" onClick={() => navigate("/cart")}>
                            Try Again
                        </Button>,
                    ]}
                />
            )}
        </div>
    );
};

export default PaypalSuccess;